/**
 * Testi italiani della conversazione con il relay di un set.
 */

/** Testi della conversazione. */
export const conversation = {
  /** Titolo della scheda, per gli assistivi. */
  title: 'Conversazione con l’Institore',
  /** Nome accessibile dell'elenco dei messaggi. */
  logLabel: 'Messaggi scambiati con l’Institore',
  /** Nessun messaggio. */
  empty: "Nessun messaggio. Scrivi all’Institore che cosa vuoi fare: lo passa all'orchestratore, che organizza gli agenti.",
  /** Prima lettura non riuscita. */
  loadFailed: 'Caricamento della conversazione non riuscito. Riprova.',
  /** Aggiornamento periodico non riuscito. */
  pollFailed: 'Aggiornamento della conversazione non riuscito. Riprovo fra poco.',
  /** Invio non riuscito. */
  sendFailed: 'Invio non riuscito. Riprova.',
  /** Nome del relay sopra le risposte. */
  relay: 'Institore',
  /** Nome accessibile di un messaggio. */
  messageFrom: 'Messaggio di {{author}} delle {{time}}',
  /** Nome accessibile di una risposta. */
  replyLabel: 'Risposta dell’Institore',
  /** Nome accessibile dell'elenco degli allegati di un messaggio. */
  attachments: 'Allegati',
  /** Attesa della prima attività. */
  working: 'L’Institore sta lavorando…',
  /** Titolo di un messaggio fallito. */
  failedTitle: 'Richiesta non completata',
  /** Testo di un messaggio fallito senza dettaglio. */
  failedText: 'L’Institore non ha completato la richiesta. Riprova o riformulala.',
  /** Relay avviato. */
  relayStarted: 'Institore avviato.',
  /** Avvio del relay non riuscito. */
  relayStartFailed: 'Avvio dell’Institore non riuscito. Riprova.',

  /** Stato di un messaggio. */
  status: {
    /** In coda. */
    queued: 'In coda',
    /** In corso. */
    running: 'In corso',
    /** Completato. */
    done: 'Completato',
    /** Non riuscito. */
    failed: 'Non riuscito',
    /** Annullato. */
    cancelled: 'Annullato',
  },

  /** Ciò che impedisce alla conversazione di andare avanti. */
  blocked: {
    /** Titolo: credenziale mancante. */
    credentialTitle: 'Manca la credenziale di Claude',
    /** Conseguenza. */
    credentialText: 'Senza, l’Institore e gli agenti non partono.',
    /** Comando. */
    credentialAction: 'Aggiungi credenziale',
    /** Titolo: relay fermo. */
    relayTitle: 'L’Institore è fermo',
    /** Conseguenza. */
    relayText: 'I messaggi restano in coda finché non lo avvii.',
    /** Comando. */
    relayAction: 'Avvia l’Institore',
  },

  /** Set in pausa per inattività (ADR 0025 §4.1). */
  sleeping: {
    /** Titolo. */
    title: 'Set in pausa',
    /** Che cosa succede. */
    text: 'Dopo 30 minuti senza attività il set si mette in pausa. Il prossimo messaggio lo riaccende.',
    /** Dopo l'invio a un set in pausa. */
    waking: 'Il set si sta riaccendendo. Il messaggio parte appena è pronto.',
    /** Nome accessibile dell'icona con la spiegazione. */
    info: 'Che cosa vuol dire',
  },

  /** Annullamento di un messaggio. */
  cancel: {
    /** Etichetta del pulsante. */
    label: 'Annulla',
    /** Nome accessibile della riga. */
    accessibleName: 'Annulla il messaggio delle {{time}}',
    /** Domanda della conferma. */
    question: 'Annullare il messaggio?',
    /** Che cosa succede. */
    consequence: 'L’Institore interrompe il lavoro su questa richiesta.',
    /** Esito fallito. */
    failed: 'Annullamento non riuscito. Riprova.',
  },

  /** Chi ha risposto a un messaggio (proposta D16). */
  handledBy: {
    /** Risposta data dall'Institore da solo. */
    institore: 'Risposta dell’Institore',
    /** Risposta con il lavoro dell'orchestratore. */
    orchestratore: 'Lavoro dell’orchestratore',
  },

  /** «Chiedi all'orchestratore» sotto una risposta diretta (proposta D17). */
  forward: {
    /** Etichetta del pulsante. */
    label: 'Chiedi all’orchestratore',
    /** Nome accessibile del pulsante. */
    accessibleName: 'Chiedi all’orchestratore la richiesta delle {{time}}',
    /** Che cosa fa, nel suggerimento. */
    help: 'Manda la stessa richiesta all’orchestratore, che lavora sui progetti',
    /** Esito fallito. */
    failed: 'Invio all’orchestratore non riuscito. Riprova.',
  },

  /** Suggerimento quando si scrive mentre il set lavora (domanda Q1). */
  busyHint:
    'Il set sta lavorando a una richiesta. Il tuo messaggio parte quando il lavoro finisce. Intanto segui l’attività.',

  /** Attività di un messaggio. */
  activity: {
    /** Apre l'elenco. */
    show: 'Mostra attività',
    /** Chiude l'elenco. */
    hide: 'Nascondi attività',
    /** Subagenti avviati. */
    subagents_one: '{{count}} subagente',
    /** Subagenti avviati. */
    subagents_other: '{{count}} subagenti',
    /** Strumenti usati. */
    tools_one: '{{count}} strumento',
    /** Strumenti usati. */
    tools_other: '{{count}} strumenti',
    /** Errori. */
    errors_one: '{{count}} errore',
    /** Errori. */
    errors_other: '{{count}} errori',
    /** Eventi senza strumenti. */
    events_one: '{{count}} evento',
    /** Eventi senza strumenti. */
    events_other: '{{count}} eventi',
    /** Ultimo strumento in uso. */
    now: 'Ora: {{tool}}',
  },

  /** Campo di scrittura. */
  composer: {
    /** Nome del form. */
    form: 'Nuovo messaggio',
    /** Etichetta del campo. */
    label: 'Messaggio per l’Institore',
    /** Aiuto sotto il campo. */
    help: 'Invio con Ctrl+Invio. Invio da solo va a capo.',
    /** Aiuto con l'invio da Invio (preferenza delle Impostazioni). */
    helpEnter: 'Invio con Invio. Maiusc+Invio o Ctrl+Invio vanno a capo.',
    /** Pulsante di invio. */
    send: 'Invia',
    /** Campo vuoto all'invio. */
    empty: 'Scrivi il messaggio prima di inviarlo.',
    /** Oltre il limite. */
    tooLong: 'Il messaggio supera i 32 KiB. Accorcialo o dividilo in più messaggi.',
    /** Contatore vicino al limite. */
    counter: '{{used}} di {{max}} byte',
    /** Selettore del progetto del messaggio (ADR 0018 §4). */
    project: 'Progetto',
    /** Tutti i progetti del set. */
    projectAll: 'Tutti i progetti',
    /** Pulsante che sceglie i file. */
    attach: 'Allega file',
    /** Vincoli degli allegati (ADR 0016). */
    attachHelp: 'Fino a 10 file da 20 MiB.',
    /** Pulsante della voce nel campo (apre il pannello «Parla»). */
    talk: 'Parla con la voce del set',
    /** Nome accessibile dell'elenco dei file scelti. */
    files: 'File da allegare',
    /** Nome accessibile del comando che toglie un file. */
    removeFile: 'Togli {{name}}',
    /** File in caricamento. */
    uploading: 'In caricamento',
    /** File pronto. */
    uploaded: 'Pronto',
    /** File non caricato. */
    uploadFailed: 'Non caricato',
    /** Troppi file. */
    tooMany: 'Al massimo 10 file per messaggio.',
    /** File troppo grande. */
    tooLarge: '{{name}} supera 20 MiB. Scegli un file più piccolo.',
    /** Invio durante un caricamento. */
    waitUploads: 'Aspetta la fine dei caricamenti, poi invia.',
  },

  /** Relay a tre colonne (ADR 0030 §3). */
  relayView: {
    /** Titolo della sezione, per gli assistivi. */
    title: 'Institore',
    /** Pulsante che spiega il nome. */
    why: 'Perché Institore?',
    /** Titolo della spiegazione. */
    whyTitle: 'Perché si chiama Institore',
    /** Spiegazione del nome. */
    whyText:
      'Nel diritto italiano l’institore è chi gestisce un’impresa per conto del titolare (art. 2203 del codice civile). Qui fa lo stesso: riceve le tue richieste e dirige gli altri agenti per tuo conto. Da qui viene il nome institorAI.',
    /** Colonna sinistra. */
    requests: 'Richieste',
    /** Filtro della colonna sinistra. */
    requestsFilter: 'Progetto delle richieste',
    /** Nessuna richiesta. */
    requestsEmpty: 'Nessuna richiesta.',
    /** Nessuna richiesta per il progetto scelto. */
    requestsEmptyFiltered: 'Nessuna richiesta per questo progetto.',
    /** Richiesta di soli allegati. */
    requestFiles: 'Solo allegati',
    /** Colonna destra. */
    workers: 'Chi sta lavorando',
    /** Richiesta seguita nella colonna destra. */
    workersFor: 'Richiesta delle {{time}}',
    /** Pulsante che chiude la colonna «Richieste». */
    hideRequests: 'Chiudi le richieste',
    /** Pulsante che riapre la colonna «Richieste». */
    showRequests: 'Apri le richieste',
    /** Pulsante che chiude la colonna «Chi sta lavorando». */
    hideWorkers: 'Chiudi chi sta lavorando',
    /** Pulsante che riapre la colonna «Chi sta lavorando». */
    showWorkers: 'Apri chi sta lavorando',
    /** Nessuna attività. */
    workersEmpty: 'Nessun agente al lavoro. Le attività compaiono qui appena l’Institore prende una richiesta.',
    /** Striscia sopra il campo: subagenti al lavoro anche a richiesta chiusa (uno). */
    backgroundWork_one: '{{count}} agente al lavoro',
    /** Striscia sopra il campo: subagenti al lavoro anche a richiesta chiusa (più di uno). */
    backgroundWork_other: '{{count}} agenti al lavoro',
    /** Testo della striscia. */
    backgroundWorkText: 'Puoi scrivere lo stesso: l’Institore risponde subito o mette in coda il lavoro nuovo.',
    /** Pulsante della voce: il pannello prende il posto della colonna destra. */
    talk: 'Parla',
  },
};

/** Forma dei testi della conversazione. */
export type Conversation = typeof conversation;
